import checkStatus from '../../../utils/checkStatus';
import R from 'ramda';

export const updateFormData = (payload, actionType, collection) => (dispatch, getState) => {
  const productId = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']);
  const locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
  if (actionType === 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG') dispatch({ type: actionType, payload: { keyPath: payload.keyPath, value: payload.value } })
  else dispatch({ type: actionType, payload });
  const composedUrl = `/proxy/contracting/formData/${collection}`;
  return fetch(composedUrl, {
    method: 'put',
    credentials: 'same-origin',
    body: JSON.stringify(R.merge(payload, { locationId, productId })),
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  })
    .then(checkStatus)
    .then(() => {
      return dispatch({ type: 'UPDATE_FORM_DATA_SUCCESS', payload: { [payload.fieldName]: payload.value } });
    })
    .catch(err => console.log(err));
};




// WEBPACK FOOTER //
// ./src/app/stores/contracting/add-rates-wizard/rates-wizard-actions.js